import Contributors from "./Contributors";
import ContactUs from "./ContactUs";
import AboutLayout from "./AboutLayout";
import Policies from "./Policies";
import History from "./History";
import Links from "./Links";
import InfoReusePolicy from "./InfoReusePolicy";
import RegistrationForm from "./RegistrationForm";
import AdminLogin from "./AdminLogin";
import SessionExpired from "./SessionExpired";
import UserLogin from "../User/UserLogin";

const module = {
  routeProps: {
    path: "/About",
    component: AboutLayout,
  },
  name: "About",
  label: "About",
  submodules: [
    ContactUs,
    Policies,
    History,
    Contributors,
    Links,
    InfoReusePolicy,
    RegistrationForm,
    AdminLogin,
    UserLogin,
    SessionExpired,
  ],
  showOnHeader: true,
  defaultOpen: false,
};

export default module;
